/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesemptydescription2Inputs */

const zh_learn_mistakesemptydescription2 = /** @type {(inputs: Learn_Mistakesemptydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成学习后，答错的题目会自动收集到这里。`)
};

const en_learn_mistakesemptydescription2 = /** @type {(inputs: Learn_Mistakesemptydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect answers will be automatically collected here after you complete study sessions.`)
};

const es_learn_mistakesemptydescription2 = /** @type {(inputs: Learn_Mistakesemptydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las respuestas incorrectas se recopilarán automáticamente aquí después de completar las sesiones de estudio.`)
};

/**
* | output |
* | --- |
* | "Incorrect answers will be automatically collected here after you complete study sessions." |
*
* @param {Learn_Mistakesemptydescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesemptydescription2 = /** @type {((inputs?: Learn_Mistakesemptydescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesemptydescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesemptydescription2(inputs)
	if (locale === "en") return en_learn_mistakesemptydescription2(inputs)
	return es_learn_mistakesemptydescription2(inputs)
});
export { learn_mistakesemptydescription2 as "learn_mistakesEmptyDescription" }